import { LAB_VITAL_INTERPRETATION } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Response = {
    status: string;
    error: string;
    response: LabVitalInterpretationResponse[];
};

export interface LabVitalInterpretationResponse {
    interpretation_eka_id: string;
    interpretation_info: {
        eka_id: string;
        meta: {
            normalised: {
                cf: number;
                range: {
                    high: number;
                    low: number;
                    text: string;
                };
                unit: string;
                unit_eka_id: string;
                val: number;
            };
            range: {
                high: number;
                low: number;
                text: string;
            };
            source: string;
            value_type: string;
        };
    };
    normalised: {
        cf: 1.0;
        range: {
            high: number;
            low: number;
            text: string;
        };
        unit: string;
        unit_eka_id: string;
        val: number;
    };
    range: {
        high: number;
        low: number;
        text: string;
    };
    source: string;
    value_type: string;
}
[];

export interface LabVitalInterpretation {
    request_id: string;
    normalisation: boolean;
    request_body: {
        eka_id?: string;
        value?: number;
        value_unit?: string;
        report_range_low?: number;
        report_range_high?: number;
        value_unit_eka_id?: string;
        gender?: string;
        age?: number;
        age_unit?: 'years' | 'months' | 'days' | 'weeks';
    }[];
}

export default async (LabVitalInterpretation: LabVitalInterpretation): Promise<Response> =>
    fetchWithRefresh(LAB_VITAL_INTERPRETATION, {
        method: 'POST',
        body: JSON.stringify(LabVitalInterpretation),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('LabVitalInterpretation api failed');
        }
    });
